import {
  AbarbeitungStatusType,
  VorgangProzessSchrittStatus,
} from '@core/domain';
import { VorgangDetail } from '@/types';

type Abarbeitung = VorgangDetail['abarbeitungen'][number];

export function getLetztenSchrittDerAbarbeitung(
  abarbeitung: Abarbeitung | undefined,
): Abarbeitung['schritte'][number] | undefined {
  if (!abarbeitung) return undefined;

  const schritte = [...abarbeitung.schritte].sort(
    (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
  );
  const aktuelleSchritte = schritte.filter(
    (schritt) => schritt.schritt === abarbeitung.aktuellerSchritt,
  );

  if (abarbeitung.status === AbarbeitungStatusType.FEHLER) {
    const fehlerhafterSchritt = aktuelleSchritte.find(
      (schritt) => schritt.status === VorgangProzessSchrittStatus.FEHLER,
    );
    if (fehlerhafterSchritt) return fehlerhafterSchritt;
  }

  return (
    aktuelleSchritte.find(
      (schritt) =>
        schritt.status === VorgangProzessSchrittStatus.IN_BEARBEITUNG ||
        schritt.status === VorgangProzessSchrittStatus.OFFEN,
    ) ??
    aktuelleSchritte[0] ??
    schritte[0]
  );
}
